const EnumReviewStatus = {
  DRAFT: "DRAFT",
  NEW_ARTICLE: "NEW_ARTICLE",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
  MAJOR_REVISION: "MAJOR_REVISION",
  MINOR_REVISION: "MINOR_REVISION",
  REVIEWED: "REVIEWED",
  UNDER_REVIEW: "UNDER_REVIEW",
  REVIEWER_SELECTION: "REVIEWER_SELECTION",
  DIRECT_REJECT: "DIRECT_REJECT",
  CORRECTION: "CORRECTION",
  REJECTED_R0: "REJECTED_R0",
  DIRECT_REJECT_R0: "DIRECT_REJECT_R0",
  REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR: "REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR",
  ASSOCIATE_EDITOR: "ASSOCIATE_EDITOR",
  RETURNED_TO_EDITOR: "RETURNED_TO_EDITOR",
};

export default EnumReviewStatus;
